export default "__VITE_ASSET__951c2273__"